import {
  Box,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { getReasonEntity } from "../../utils/Filters";
import { v4 as uuidv4 } from "uuid";
import dayjs from "dayjs";
function ViewInput({
  availableDiscountReason,
  viewType,
  payment,
  totalAmount,
  setTotalAmount,
  userDetails,
  onViewChange,
  errors,
}) {
  const theme = useTheme();
  const [formIdentifier, setFormIdentifier] = useState(null);
  const [discounted, setDiscounted] = useState(false);
  const [viewData, setViewData] = useState({
    quantity: 0,
    amount: 0,
    discounted: false,
    netAmount: 0,
    discountReason: "",
    customReason: "",
    PaymentMethodId: payment?.id,
    SiteId: userDetails.site.id,
    WorkTimeId: userDetails.worktime.id,
    customWorkTime: userDetails.customWorkTime,
    UserId: userDetails.user.id,
    ViewTypeId: viewType.id,
    DiscountReasonId: null,
    date: dayjs(userDetails.date).format("YYYY-MM-DD"),
    identifier: null,
  });

  useEffect(() => {
    const newIdentifier = uuidv4();
    setFormIdentifier(newIdentifier);
    setViewData((prev) => ({ ...prev, identifier: newIdentifier }));

    if (payment?.name === "Website") {
      setDiscounted(true);
      setViewData((prev) => ({ ...prev, discounted: false }));
    }
  }, [payment]);

  useEffect(() => {
    if (formIdentifier) {
      onViewChange(formIdentifier, viewData);
    }
  }, [viewData, formIdentifier]);

  const updateViewData = (updates) => {
    setViewData((prev) => {
      const updatedData = { ...prev, ...updates };
      onViewChange(formIdentifier, updatedData);
      return updatedData;
    });
  };

  const handleQuantityChange = (e) => {
    let newQuantity = e.target.value.trim();
    if (newQuantity === "") {
      newQuantity = "";
    } else if (!/^\d+$/.test(newQuantity)) {
      return;
    } else {
      newQuantity = parseInt(newQuantity, 10);
    }

    if (newQuantity < 0) {
      newQuantity = 0;
    }
    if (payment?.name === "مشاهدات مجانية") {
      updateViewData({ quantity: newQuantity, amount: 0, netAmount: 0 });
    } else {
      const newAmount = newQuantity * viewType.defaultPrice;
      updateViewData({
        quantity: newQuantity,
        amount: newAmount,
        netAmount: newAmount,
      });
      setTotalAmount(totalAmount + newAmount - viewData.amount);
    }
  };

  const handleAmount = (e) => {
    let newAmount = e.target.value;
    let amountToUse;
    const defaultPrice = viewData.quantity * viewType.defaultPrice;

    if (!/^\d*\.?\d*$/.test(newAmount)) {
      return;
    } else if (newAmount === ".") {
      return;
    } else if (newAmount === "") {
      amountToUse = 0;
    } else if (newAmount.endsWith(".")) {
      const dotsCount = newAmount.split(".").length - 1;
      if (dotsCount > 1) {
        return;
      }
      amountToUse = parseFloat(newAmount).toFixed(3);
    } else if (parseFloat(newAmount) > defaultPrice) {
      newAmount = defaultPrice;
      amountToUse = parseFloat(newAmount).toFixed(3);
    } else {
      newAmount = Math.floor(parseFloat(newAmount) * 1000) / 1000;
      amountToUse = parseFloat(newAmount).toFixed(3);
    }

    setTotalAmount((prev) => prev + (amountToUse - viewData.amount));
    updateViewData({ amount: newAmount });
  };

  const handleDiscountSwitch = () => {
    const defaultPrice = viewData.quantity * viewType.defaultPrice;
    if (discounted) {
      setDiscounted(false);
      updateViewData({
        amount: defaultPrice,
        discounted: false,
        discountReason: "",
      });
      setTotalAmount(totalAmount + defaultPrice - viewData.amount);
    } else {
      setDiscounted(true);
      updateViewData({
        discounted: true,
      });
    }
  };

  const handleDiscountReasonChange = (e) => {
    const selectedReason = e.target.value;
    const reason = getReasonEntity(availableDiscountReason, selectedReason);
    updateViewData({
      discountReason: selectedReason,
      DiscountReasonId: reason.id,
      customReason: "",
    });
  };

  const handleCustomReasonChange = (e) => {
    const reason = e.target.value;
    updateViewData({ DiscountReasonId: null, customReason: reason });
  };

  let viewImage = "Other";
  if (viewType.name === "كراسي الراحة") {
    viewImage = "Headset";
  } else if (viewType.name === "كراسي المغامرة") {
    viewImage = "Chair";
  } else {
    viewImage = "Other";
  }
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flexWrap: "nowrap",
        rowGap: "20px",
        width: { xs: "100%", sm: "100%", md: "100%", lg: "auto" },
        margin: { xs: "12px 0" },
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box
          sx={{
            width: "60px",
            height: "60px",
            borderRadius: "100px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          bgcolor={theme.palette.neutral[50]}
        >
          <img src={`/assets/${viewImage}.svg`} alt="icon" />
        </Box>
        <Box sx={{ marginLeft: "12px" }}>
          <Typography variant="caption" color={theme.palette.neutral[800]}>
            مشاهدات
          </Typography>
          <Typography variant="h6" color={theme.palette.neutral[800]}>
            {viewType.name}
          </Typography>
        </Box>
      </Box>
      <FormControl fullWidth sx={{ minWidth: "250px" }}>
        <TextField
          fullWidth
          label="عدد المشاهدات"
          type="text"
          value={viewData.quantity}
          onChange={handleQuantityChange}
          error={!!errors[formIdentifier]?.quantity}
          helperText={errors[formIdentifier]?.quantity}
        />
      </FormControl>
      {payment?.showAmount ? (
        <FormControl fullWidth sx={{ minWidth: "250px" }}>
          <TextField
            fullWidth
            label="المبلغ النهائي"
            type="text"
            value={viewData.amount}
            onChange={handleAmount}
            error={!!errors[formIdentifier]?.amount}
            helperText={errors[formIdentifier]?.amount}
            disabled={!discounted}
          />
        </FormControl>
      ) : (
        ""
      )}
      {payment?.allowDiscount && (
        <>
          <FormControl fullWidth sx={{ minWidth: "250px" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <Typography variant="body1" color={theme.palette.neutral[800]}>
                يوجد خصم؟
              </Typography>
              <FormControlLabel
                value="bottom"
                control={
                  <Switch
                    color="primary"
                    checked={discounted}
                    disabled={viewData.amount <= 0 && !discounted}
                    onClick={handleDiscountSwitch}
                  />
                }
              />
            </Box>
          </FormControl>

          {availableDiscountReason && discounted && (
            <FormControl
              fullWidth
              sx={{ flex: "1 1 100%", minWidth: "250px" }}
              error={!!errors[formIdentifier]?.discountReason}
            >
              <InputLabel id="site-label">سبب الخصم</InputLabel>
              <Select
                fullWidth
                labelId="site-label"
                label="سبب الخصم"
                value={viewData.discountReason}
                onChange={handleDiscountReasonChange}
              >
                {availableDiscountReason.map((e, index) => (
                  <MenuItem key={index} value={e.reason}>
                    {e.reason}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>
                {errors[formIdentifier]?.discountReason}
              </FormHelperText>
            </FormControl>
          )}

          {viewData.discountReason === "سبب آخر" && (
            <FormControl sx={{ flex: "1 1 45%", minWidth: "250px" }}>
              <TextField
                fullWidth
                label="سبب مخصص"
                type="text"
                error={!!errors[formIdentifier]?.customReason}
                helperText={errors[formIdentifier]?.customReason}
                multiline={true}
                rows={4}
                value={viewData.customReason}
                onChange={handleCustomReasonChange}
              />
            </FormControl>
          )}
        </>
      )}
    </Box>
  );
}

export default ViewInput;
